import axios from 'axios';
import { headers } from './TokenHeader';
import { Urls } from './ApiPath';
import { Auth } from "../auth/Auth";
const API_KEY = process.env.REACT_APP_API_KEY;
const options = {
	headers: {'x-access-token': Auth.token()}
  };
const findAll = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${Urls.drugCategories.v3.findAll}`,{headers:headers})
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

const save = (category ) => {
	return new Promise((resolve, reject) => {
		axios.post(Urls.drugCategories.v3.save, category, { headers: headers })
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
	});
};

const edit = (category ) => {
	return new Promise((resolve, reject) => {
		axios.put(Urls.drugCategories.v3.edit, category, { headers: headers })
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
	});
};

export const DrugCategoryService = {
	findAll: findAll,
	save: save,
	edit
}